/**
 * This object defines criteria for ignoring specific console warnings and errors
 * during the development process. The purpose is to reduce noise from known issues
 * that are not immediately actionable, allowing developers to focus on more critical
 * tasks. However, these warnings and errors should be addressed and resolved in the
 * future to ensure code quality and maintainability.
 */
const consoleIgnoreCriteria = {
  warn: [
    'Expected server HTML to contain a matching',
    'An error occurred during hydration',
    'Hydration failed because the initial UI does not match',
    'Failed to initialize reCAPTCHA Enterprise config'
  ],
  error: [
    'Support for defaultProps will be removed from function components',
    "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node",
    'Hydration failed because the initial UI does not match',
    'There was an error while hydrating',
    'Error: Hydration failed because the initial UI does not match what was rendered on the server.'
  ]
};

export default consoleIgnoreCriteria;
